import React from "react";

const hexToRgba = (hex, alpha) => {
  const h = (hex || "#f3f3f3").replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

const SmartphonePreview = ({
  primaryColor,
  secondaryColor,
  backgroundColor,
  textPrimary,
  textSecondary,
  logoBase64,
  backgroundSmartphoneImage,
  backgroundImage,
  languageSelectorColor,
  buttonColor1,
  buttonColor2,
  buttonText,
  iconsColor,
}) => {
  const grad  = `linear-gradient(to right, ${primaryColor || "#01315f"}, ${secondaryColor || "#067ddb"})`;
  const bg    = backgroundColor || "#f3f3f3";
  const tp    = textPrimary    || "#01315f";
  const ts    = textSecondary  || "#444444";
  const lsc   = languageSelectorColor || "#ffffff";
  const bc1   = buttonColor1   || "#01315f";
  const bc2   = buttonColor2   || "#067ddb";
  const bt    = buttonText     || "#ffffff";
  const ic    = iconsColor     || "#01315f";
  const bgImg = backgroundSmartphoneImage || backgroundImage;

  const btnBase = {
    border: "none",
    borderRadius: "8px",
    padding: "9px 0",
    fontSize: "11px",
    fontWeight: 600,
    cursor: "default",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    width: "100%",
  };

  return (
    <div
      style={{
        position: "relative",
        width: "220px",
        height: "390px",
        margin: "0 auto",
        backgroundColor: bg,
        backgroundImage: bgImg ? `url(${bgImg})` : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
        fontFamily: "sans-serif",
        border: "4px solid #222",
      }}
    >
      {/* Phone notch */}
      <div style={{
        position: "absolute",
        top: 0, left: "50%",
        transform: "translateX(-50%)",
        width: "60px", height: "14px",
        background: "#222",
        borderRadius: "0 0 10px 10px",
        zIndex: 10,
      }} />

      {/* Header */}
      <div
        style={{
          position: "absolute",
          top: 0, left: 0, right: 0,
          height: "44px",
          background: grad,
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          padding: "0 10px 6px",
          zIndex: 2,
        }}
      >
        <img
          src={logoBase64 || "/images/logo_white.png"}
          alt="Logo"
          style={{ height: "16px", width: "auto", maxWidth: "80px", objectFit: "contain", flexShrink: 0, display: "block" }}
        />
        <div style={{ color: lsc, display: "flex", alignItems: "center", gap: "3px", fontSize: "9px", fontWeight: 600 }}>
          <i className="fas fa-globe" style={{ fontSize: "9px" }}></i>
          <span>ES</span>
        </div>
      </div>

      {/* Body */}
      <div
        style={{
          position: "absolute",
          top: "44px", left: 0, right: 0, bottom: 0,
          backgroundColor: bgImg ? hexToRgba(bg, 0.88) : bg,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 12px",
          gap: "7px",
        }}
      >
        <i className="fas fa-lock" style={{ fontSize: "18px", color: ic }}></i>

        <div style={{ textAlign: "center" }}>
          <div style={{ color: tp, fontSize: "11px", fontWeight: 700, marginBottom: "2px" }}>Selecciona tu taquilla</div>
          <div style={{ color: ts, fontSize: "9px", lineHeight: 1.4 }}>Elige el tipo de alquiler</div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>
          <button style={{ ...btnBase, background: bc1, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Pequeña
          </button>
          <button style={{ ...btnBase, background: bc2, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Mediana
          </button>
          <button style={{ ...btnBase, background: bc1, color: bt }}>
            <i className="fas fa-box" style={{ fontSize: "9px", color: bt }}></i>
            Grande
          </button>
        </div>

        <button style={{ ...btnBase, background: bc1, color: bt, borderRadius: "8px" }}>
          <i className="fas fa-check" style={{ fontSize: "9px" }}></i>
          Continuar
        </button>
      </div>
    </div>
  );
};

export default SmartphonePreview;
